import ArticleCategoriesNav from "@/components/ArticleCategoriesNav";
import Paginate from "@/components/Paginate";
import { useAdContext } from "@/contexts/AdContext";
import craft from "@/lib/craft";
import getCommonStaticProps from "@/lib/getCommonStaticProps";
import QueryArticles from "@/queries/QueryArticles.graphql";
import QueryArticlesIndex from "@/queries/QueryArticlesIndex.graphql";
import clsx from "clsx";
import EntryGrid from "components/EntryGrid";
import Heading from "components/Heading";
import Head from "next/head";
import { useEffect } from "react";
import { Seomatic } from "react-seomatic";

const limit = 30;

export async function getStaticPaths() {
  // Just prerender 1 page
  const paths = [];

  paths.push({ params: { pageNumber: "1" } });

  return {
    paths,
    fallback: "blocking",
  };
}

export async function getStaticProps({ params, previewData, preview }) {
  // Fetch common static properties
  const commonStaticProps = await getCommonStaticProps();

  const pageNumber = parseInt(params.pageNumber);

  const response = await craft([
    {
      document: QueryArticlesIndex,
    },
    {
      document: QueryArticles,
      variables: { limit, offset: (pageNumber - 1) * limit },
    },
  ]);

  const { pageEntry, articlesCount } = response[0];
  const { articles } = response[1];

  return {
    props: {
      ...commonStaticProps,
      pageEntry,
      seomatic: pageEntry.seomatic,
      articlesCount,
      articles,
      pageNumber,
    },
    revalidate: process.env.VERCEL_ENV !== "production" ? 1 : 3600,
  };
}

const LifeAll = ({ pageEntry, articles, articlesCount, pageNumber }) => {
  // Set showAds to true for this page
  const { setShowAds } = useAdContext();
  useEffect(() => setShowAds(true));

  return (
    <>
      <Seomatic Head={Head} {...pageEntry.seomatic} />
      <ArticleCategoriesNav />

      <Heading
        heading={`Life ・ Page ${pageNumber}`}
        spaceAbove="medium"
        spaceBelow="medium"
      />

      <div className={clsx("mb-12 px-6 lg:px-12")}>
        <EntryGrid entries={articles} />
      </div>

      <div className={clsx("border-t")}>
        <Paginate
          pageCount={Math.floor(articlesCount / 30)}
          activePage={pageNumber}
          baseUri="/life"
        />
      </div>
    </>
  );
};

export default LifeAll;
